var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03A9F4",
    d: "M23 5.132c-.828.364-1.703.605-2.599.717.945-.564 1.65-1.457 1.984-2.51-.884.528-1.85.9-2.859 1.099-.618-.665-1.421-1.128-2.304-1.328-.883-.2-1.805-.127-2.647.208-.842.335-1.563.918-2.072 1.671-.509.754-.78 1.645-.78 2.556-.003.348.032.695.105 1.034-1.794-.088-3.55-.557-5.152-1.376-1.602-.818-3.014-1.968-4.144-3.374-.58 1-.76 2.184-.503 3.312.257 1.128.932 2.114 1.888 2.758-.714-.02-1.413-.211-2.037-.56v.05c.001 1.049.361 2.065 1.02 2.878.657.813 1.573 1.373 2.593 1.585-.385.102-.783.153-1.182.15-.287.005-.573-.022-.854-.078.292.901.853 1.69 1.608 2.256.755.566 1.666.884 2.607.907-1.597 1.258-3.566 1.94-5.592 1.937-.361.003-.722-.018-1.08-.062C3.062 20.3 5.465 21.008 7.919 21c8.3 0 12.837-6.922 12.837-12.923 0-.2-.007-.395-.017-.587.89-.641 1.656-1.44 2.261-2.358z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-twitter.a784383a.svg";
export { ForwardRef as ReactComponent };